import userCourseHistoryApi from 'Api/axios/user-course-histories-api';
import { useEffect, useState } from 'react';
import type { HistoryReportFilterI, HistoryReportI, JsonApiMetaI } from 'types';

interface Props {
  init?: boolean;
}

const useHistoryReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<HistoryReportI[]>([]);
  const [meta, setMeta] = useState<JsonApiMetaI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistoryReport = async (filters: HistoryReportFilterI = {}) => {
    setLoading(true);
    setError(null);

    const response = await userCourseHistoryApi.getEmployeesCollection(filters);

    setLoading(false);

    if (response.data) {
      setData(response.data ?? []);
      setMeta(response.meta ?? null);
    } else {
      setError(response.error ?? 'No hay datos disponibles');
    }
  };

  useEffect(() => {
    if (init) {
      fetchHistoryReport();
    }
  }, [init]);

  return { data, meta, loading, error, fetchHistoryReport };
};

export default useHistoryReportApi;
